import {
    FetchDocumentTypeAction,
    GetLoketInfoAction,
} from './pzModels'

export const fetchDocumentTypes = (): FetchDocumentTypeAction => ({
    type: 'PZ_SAGA_GET_DOCUMENT_TYPES',
})

export const getLoketInfo = (): GetLoketInfoAction => ({ type: 'PZ_SAGA_GET_LOKET_INFO' })
